import { useEffect, useRef, useState } from 'react';
import { loadPlayer, PLAYER_EVENT } from '../game/player';
import { Icons } from './icons';

// The Slime tab's mark: this student's own slime, drawn in chalk from its saved look. Before there is a
// slime (or while the chalk code loads) it is the plain line slime.
export function SlimeIcon() {
  const ref = useRef<HTMLCanvasElement>(null);
  const [look, setLook] = useState(() => loadPlayer()?.look ?? null);
  const [drawn, setDrawn] = useState(false);
  useEffect(() => {
    const on = () => setLook(loadPlayer()?.look ?? null);
    window.addEventListener(PLAYER_EVENT, on);
    return () => window.removeEventListener(PLAYER_EVENT, on);
  }, []);
  const key = JSON.stringify(look);
  useEffect(() => {
    if (!look) return setDrawn(false);
    let live = true;
    import('../game/chalk/draw')
      .then(({ chalkSlime, drawSprite }) => {
        const c = ref.current;
        const g = c?.getContext('2d');
        if (!live || !c || !g) return;
        const R = Math.min(window.devicePixelRatio || 1, 3);
        c.width = Math.round(c.clientWidth * R);
        c.height = Math.round(c.clientHeight * R);
        const sp = chalkSlime(look, 40, 7);
        g.clearRect(0, 0, c.width, c.height);
        drawSprite(g, sp, c.width / 2, c.height * 0.97, (c.width / sp.canvas.width) * 1.4, 0, 1, 7);
        setDrawn(true);
      })
      .catch(() => undefined);
    return () => {
      live = false;
    };
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <span className="slime-icon">
      {!drawn && Icons.play}
      <canvas ref={ref} aria-hidden="true" style={drawn ? undefined : { position: 'absolute', opacity: 0 }} />
    </span>
  );
}
